import React from "react";
import { IconSize, IconProps } from "../theme";

const User: React.FC<IconProps> = ({ size = IconSize.M }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.8662 27.5005C28.7785 27.6525 28.6522 27.7788 28.5001 27.8666C28.3481 27.9543 28.1756 28.0005 28 28.0005H4C3.82455 28.0003 3.65223 27.954 3.50036 27.8661C3.34848 27.7783 3.22239 27.652 3.13474 27.5C3.04709 27.348 3.00098 27.1757 3.00102 27.0002C3.00107 26.8248 3.04727 26.6524 3.135 26.5005C5.03875 23.2092 7.9725 20.8492 11.3962 19.7305C9.70271 18.7223 8.38693 17.1861 7.65098 15.3577C6.91503 13.5294 6.7996 11.51 7.32242 9.60967C7.84524 7.70936 8.9774 6.03321 10.545 4.83863C12.1127 3.64404 14.0291 2.99707 16 2.99707C17.9709 2.99707 19.8873 3.64404 21.455 4.83863C23.0226 6.03321 24.1548 7.70936 24.6776 9.60967C25.2004 11.51 25.085 13.5294 24.349 15.3577C23.6131 17.1861 22.2973 18.7223 20.6037 19.7305C24.0275 20.8492 26.9612 23.2092 28.865 26.5005C28.953 26.6524 28.9994 26.8248 28.9996 27.0003C28.9998 27.1758 28.9538 27.3483 28.8662 27.5005Z"
        fill="#071443"
      />
    </svg>
  );
};

export default User;
